import React, { useEffect, useRef, useState } from 'react';
import Logo from '../../../assets/svg/logo';
// import Clefill from "../../../assets/svg/RO3.png";
import { FaBars, FaTimes, FaSearch, FaMapMarkerAlt, FaUser, FaInstagram, FaTwitter, FaFacebook } from 'react-icons/fa'
import { BsCart2 } from 'react-icons/bs'

import { RxCross2 } from "react-icons/rx";

import { Link, NavLink } from 'react-router-dom';
import { BiUser } from 'react-icons/bi';
import OutSideClick from '../../../utils/OutSideClick'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import BackArrow from '../../../assets/svg/back_arrow';
import { GET_CART_COUNT_LOCAL_ERROR, GET_CART_COUNT_LOCAL_SUCCESS, GET_CART_COUNT_SUCCESS, SHLD_REDIRECT_TO_CART, VALID_LOCATION_SUCCESS, SHOW_LOGIN_MODAL } from '../../../constants/types';
import { checkLocation, doLogout, getProfile, createAcc, onSignIn, sendOTP, verifyOTP } from '../../../redux/actions/authAction';

import { getCartCount, productList, visitorCall, addCartLocalToApi, getCart } from '../../../redux/actions/productAction';
import swal from 'sweetalert';
import { pincodeFromLatLng, removeQuotsFun, displayPhoneNumber, removeCountryCode, createDeviceId, getDeviceType } from '../../../utils';
import LoaderBox from './Loader';
import axios from 'axios';
import { FiSearch, FiX, FiMapPin, FiPhone, FiUser, FiMail } from "react-icons/fi";
import { SigninValidate, CreateAcc } from '../../../utils/validate';

import { SET_OTP_DATA } from '../../../constants/types';
import { removeMobileFomrmatter, toAbsoluteUrl, } from '../../../utils';
import { renderNumberInput, renderInput } from '../../../utils/FormField';
import { SigninValidate as validate } from '../../../utils/validate';
// import LoaderBox from '../../components/common/Loader';

import { Field, Form } from 'react-final-form';
import banner1 from "../../../assets/images/slide11.avif";
import OtpInput from 'react-otp-input';


const Header = ({ }) => {

    const dropDownRef = useRef();
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();


    const isValidLocation = useSelector(state => state.auth.isValidLocation)
    const profileData = useSelector(state => state.auth.userProfile?.profile)
    const isLoggedIn = useSelector(state => state.auth.isLoggedIn)
    const cartCountLocal = useSelector(state => state.product.cartCountLocal)
    const authData = useSelector(state => state.auth)
    const cartCount = useSelector(state => state.product.cartCount)
    const notificationCount = useSelector(state => state.userUtils.notificationCount)
    const allProductList = useSelector(state => state.product.productList)
    const [otpData, setotpData] = useState({});
    const [otpModal, setotpModal] = useState(false);
    const [Timer, setTimer] = useState(0);
    const [otpValue, setotpValue] = useState('');

    const [showDropDown, setshowDropDown] = useState(false);
    const [isLoading, setisLoading] = useState(false);
    // const [headerTitle, setheaderTitle] = useState('Clefill');
    const loginModalStatus = useSelector(state => state.auth.showLoginModal);
    // console.log(loginModalStatus)
    const [locationModal, setLocationModal] = useState(false);

    const [activeClass, setActiveClass] = useState(false);
    const [activeSearch, setActiveSearch] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const [keyword, setKeyword] = useState('')
    const deviceIp = JSON.parse(localStorage.getItem("deviceIp"));
    const sessionDeviceIp = JSON.parse(sessionStorage.getItem("deviceIp"));
    const [active, setActive] = useState("Refills");
    const [loggingModel, setLoggingModel] = useState(false);
    const [signupModal, setsignupModal] = useState(false);


    const resetOtpData = () => {
        setotpValue('')
        setotpData({})
        setTimer(0)
    };

    const handleToggle1 = () => { setLocationModal(!locationModal); };

    useEffect(() => {
        setClick(false)
        setKeyword("")
        setSuggestions([])
    }, [history.location.pathname, activeSearch]);

    useEffect(() => setActiveSearch(false), [history.location.pathname]);



    const [click, setClick] = useState(false)
    const handleClick = () => {
        if (isValidLocation) {
            setClick(!click)
        } else {
            setLocationModal(true)
        }
    }
    // Function to handle mobile app header title
    const headerTitleFunction = () => {

        if (location.pathname.includes('/profile')) {
            return 'Profile'
        } else if (location.pathname.includes('/my_address')) {
            return 'My Address'
        } else if (location.pathname.includes('/edit_address')) {
            return 'Edit Address'
        } else if (location.pathname.includes('/add_address')) {
            return 'Add New Address'
        } else if (location.pathname.includes('/cart')) {
            return 'Cart'
        } else if (location.pathname.includes('/shipping_address')) {
            return 'Shipping Address'
        } else if (location.pathname.includes('/payment_method')) {
            return 'Payment Method'
        } else if (location.pathname.includes('/payment')) {
            return 'My Payment'
        } else if (location.pathname.includes('/add_card')) {
            return 'Add Card'
        } else if (location.pathname.includes('/promocode')) {
            return 'Promocode'
        } else if (location.pathname.includes('/success')) {
            return 'Success'
        } else if (location.pathname.includes('/live_tracking')) {
            return 'Track Driver'
        } else if (location.pathname.includes('/order_detail')) {
            return 'Order Detail'
        } else if (location.pathname.includes('/order_list')) {
            return 'Order List'
        } else if (location.pathname.includes('/notifications')) {
            return 'notifications'
        } else if (location.pathname.includes('/more_help')) {
            return 'more_help'
        } else if (location.pathname.includes('/Help-List')) {
            return 'Help-List'
        } else if (location.pathname.includes('/faq')) {
            return 'faq'
        } else if (location.pathname.includes('/return')) {
            return 'return'
        } else if (location.pathname.includes('/product_list')) {
            return 'product-list'
        } else if (location.pathname.includes('/product_detail')) {
            return 'product-detail'
        } else {
            return false
        }
    };

    // Fun to get cart data for loggedin and non loggedin
    useEffect(() => {
        if (isLoggedIn) {
            dispatch(getCartCount({ customerId: profileData?.id }))
            dispatch(getProfile())
        }
        else {
            if (JSON.parse(localStorage.getItem('cartTotal'))) {
                let length = JSON.parse(localStorage.getItem('cartTotal'))
                dispatch({
                    type: GET_CART_COUNT_LOCAL_SUCCESS, payload: length
                })
            }
            else {
                dispatch({
                    type: GET_CART_COUNT_LOCAL_ERROR, payload: 0
                })
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch])

    // Function for app header title
    // useEffect(() => {
    //     setheaderTitle(headerTitleFunction());

    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [location.pathname])

    OutSideClick(dropDownRef, () => {
        if (showDropDown) { setshowDropDown(false); }
    });

    // Logout method
    const onLogout = () => {
        const fcmToken = JSON.parse(localStorage.getItem("FCMToken"));
        dispatch(doLogout({ fcmToken: fcmToken ? fcmToken : ' ' }))
        dispatch({ type: GET_CART_COUNT_SUCCESS, payload: 0 })
        dispatch({ type: SHLD_REDIRECT_TO_CART, payload: false })
        if (localStorage.getItem('cart')) {
            localStorage.removeItem('cart')
        }
        if (localStorage.getItem('cartTotal')) {
            localStorage.removeItem('cartTotal')
        }
    };

    const handleVisitorCall = () => {
        if (!sessionDeviceIp && deviceIp) {
            dispatch(
                visitorCall({
                    ipAddress: deviceIp,
                })
            );
            sessionStorage.setItem("deviceIp", JSON.stringify(deviceIp));
        }
    }

    // For Location pop up detect location api
    const onDetectLocation = (manualPinCode, type) => {

        let tmpIp = JSON.parse(localStorage.getItem("deviceIp"));
        let tmpObj = { ipAddress: tmpIp, customerId: profileData?.id ? profileData?.id : '' }

        if (type === 'manual') {
            let manualData = { pincode: manualPinCode, ...tmpObj }
            setisLoading(true)
            dispatch(checkLocation(manualData))
                .then(res => {
                    setisLoading(false)
                    setLocationModal(false)
                    axios.defaults.headers.common["pincode"] = res.data?.pincode
                    localStorage.setItem('pincode', res.data?.pincode)
                    handleVisitorCall()
                    localStorage.setItem('validLocation', JSON.stringify(res.data?.pincode + ' ' + res.data?.area?.city))
                    setTimeout(() => {
                        dispatch({ type: VALID_LOCATION_SUCCESS, payload: JSON.stringify(res.data?.pincode + ' ' + res.data?.area?.city) })
                    }, 1000);
                    dispatch(productList({
                        page: 1,
                        limit: 1000,
                        customerId: '',
                        productType: ""
                    }))
                    history.push('/')

                    //  End Date -14-03-2022
                })
                .catch(err => {
                    setisLoading(false)
                    swal('', err.message, 'error')
                })
        }
        else {
            setisLoading(true)
            //success function
            navigator.geolocation.getCurrentPosition((pos) => {
                var crd = pos.coords

                pincodeFromLatLng(crd.latitude, crd.longitude)
                    .then(pincodeRes => {
                        dispatch(checkLocation({ pincode: pincodeRes, ...tmpObj }))
                            .then(res => {
                                setisLoading(false)
                                setLocationModal(false)
                                axios.defaults.headers.common["pincode"] = res.data?.pincode
                                localStorage.setItem('pincode', res.data?.pincode)
                                handleVisitorCall()
                                localStorage.setItem('validLocation', JSON.stringify(res.data?.pincode + ' ' + res.data?.area?.city))
                                setTimeout(() => {
                                    dispatch({ type: VALID_LOCATION_SUCCESS, payload: JSON.stringify(res.data?.pincode + ' ' + res.data?.area?.city) })
                                }, 1000);
                                dispatch(productList({
                                    page: 1,
                                    limit: 1000,
                                    customerId: '',
                                    productType: ""
                                }))
                            })
                            .catch(err => {
                                setisLoading(false)
                                swal(`Detected pincode : ${pincodeRes}`, err.message, 'error')
                            })
                    })
                    .catch(err => {
                        setisLoading(false)
                        // console.log('err: ', err);
                    })

            }, (err) => {
                // error function
                setisLoading(false)
                if (err?.message) {
                    if (err?.code === 1)
                        swal('Location Permission Required', 'Please allow location permission !', 'error')
                    else if (err?.code === 2)
                        swal('Position unavailable !', 'Please try again or try by adding pincode manually !', 'error')
                    else if (err?.code === 3)
                        swal('Timed Out !', 'Please try again or try by adding pincode manually !', 'error')
                    else {
                        swal('', err?.message, 'error')
                    }
                }
                else {
                    alert('something went wrong')
                }
            }, {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0
            });
        }
    };

    const onSignUpSubmit = (data, form) => {
        dispatch(sendOTP({ phoneNumber: removeMobileFomrmatter(data.phoneNumber), type: 'register' }))
            .then(res => {
                setotpData({ ...data, phoneNumber: removeMobileFomrmatter(data.phoneNumber), type: 'register' })
                setsignupModal(false)
                setTimer(60)
                setotpModal(true)
                // setisAgreed(false)
                form?.restart()
            })
            .catch(err => {
                swal('', err.message, 'error')
                // resetOtpData()
            })
    };

    const loader = useSelector(state => state.auth.loader);
    // const isLoggedIn = useSelector(state => state.auth.isLoggedIn);

    // Form Submit Method
    const onFormSubmit = (data) => {
        // console.log(data)
        dispatch(sendOTP({ phoneNumber: removeMobileFomrmatter(data.phoneNumber), type: 'login' }))
            .then(res => {
                setotpData({ ...data, phoneNumber: removeMobileFomrmatter(data.phoneNumber), type: 'login' })
                // history.push('/otp/login')
                setotpModal(true)
            })
            .catch(err => {
                // history.replace(`/signup?phoneNumber=${removeMobileFomrmatter(data.phoneNumber, true)}`)
                // swal('', err.message, 'error')
                setsignupModal(true)
                setotpData({ ...otpData, phoneNumber: removeMobileFomrmatter(data.phoneNumber) })
                setsignupModal(true)

            })
    };

    //otp
    const onOtpChange = (otp) => {
        setotpValue(otp)
    };

    const onResendOtp = () => {
        // setisLoading(true)
        dispatch(sendOTP({ phoneNumber: removeMobileFomrmatter(otpData?.phoneNumber), type: otpData?.type }))
            .then(res => {
                setTimer(60)
                // setisLoading(false)
                swal('', res.message, 'success')
            })
            .catch(err => {
                setTimer(60)
                // setisLoading(false)
                swal('', err.message, 'error')
            })
    };

    const handleOtpSubmit = (e) => {
        e.preventDefault();
        let ipAddress = JSON.parse(localStorage.getItem("deviceIp"));
        const FCMtoken = JSON.parse(localStorage.getItem('FCMToken'))
        const pincode = JSON.parse(localStorage.getItem("validLocation"));

        let pincodeLocal = '';
        if (pincode) {
            let tmpVar = pincode?.split(" ")
            if (tmpVar)
                pincodeLocal = tmpVar[0]
        }


        dispatch(verifyOTP({ otp: otpValue, phoneNumber: removeMobileFomrmatter(otpData.phoneNumber) }))
            .then(res => {
                if (otpData?.type === 'register') {
                    dispatch(createAcc({ ...otpData, phoneNumber: removeMobileFomrmatter(otpData.phoneNumber), fcmToken: FCMtoken ? FCMtoken : '123455', deviceId: createDeviceId(), deviceType: getDeviceType(), ipAddress: ipAddress || '', pincode: pincodeLocal || '' }))
                        .then(res => {
                            resetOtpData()
                            setotpModal(false)
                            setsignupModal(false)
                            dispatch({ type: SHOW_LOGIN_MODAL, payload: false });

                            dispatch(getProfile())

                            const localCartData = JSON.parse(localStorage.getItem('cart'))

                            // If local cart has any data then will be added to user cart api
                            if (localCartData && localCartData?.length) {
                                dispatch(addCartLocalToApi({ customerId: res?.data?.id, products: [...localCartData] }))
                                    .then(res2 => {
                                        dispatch(getCart({ customerId: res?.data?.id }))
                                        dispatch(getCartCount({ customerId: res?.data?.id }))
                                        if (localStorage.getItem('cart')) {
                                            localStorage.removeItem('cart')
                                        }
                                        if (localStorage.getItem('cartTotal')) {
                                            localStorage.removeItem('cartTotal')
                                        }
                                    })
                                    .catch(Err => {
                                        dispatch(getCart({ customerId: res?.data?.id }))
                                        dispatch(getCartCount({ customerId: res?.data?.id }))
                                    })
                            }
                            // If local cart has no cart data then will not be added to api
                            else {
                                dispatch(getCart({ customerId: res?.data?.id }))
                                dispatch(getCartCount({ customerId: res?.data?.id }))
                            }
                        })
                        .catch(err => {
                            swal('', err?.message, 'error')
                        })
                }
                else {
                    dispatch(onSignIn({ ...otpData, phoneNumber: removeMobileFomrmatter(otpData.phoneNumber), deviceType: getDeviceType(), deviceId: createDeviceId(), fcmToken: FCMtoken ? FCMtoken : '123455', ipAddress: ipAddress || '', pincode: pincodeLocal || '' }))
                        .then(res => {
                            resetOtpData()
                            setotpModal(false)
                            dispatch({ type: SHOW_LOGIN_MODAL, payload: false });
                            // setLoggingModel(false)
                            dispatch(getProfile())

                            const localCartData = JSON.parse(localStorage.getItem('cart'))

                            // If local cart has any data then will be added to user cart api
                            if (localCartData && localCartData?.length) {
                                dispatch(addCartLocalToApi({ customerId: res?.data?.id, products: [...localCartData] }))
                                    .then(res2 => {
                                        dispatch(getCart({ customerId: res?.data?.id }))
                                        dispatch(getCartCount({ customerId: res?.data?.id }))
                                    })
                                    .catch(Err => {
                                        dispatch(getCart({ customerId: res?.data?.id }))
                                        dispatch(getCartCount({ customerId: res?.data?.id }))
                                    })
                            }
                            // If local cart has no cart data then will not be added to api
                            else {
                                dispatch(getCart({ customerId: res?.data?.id }))
                                dispatch(getCartCount({ customerId: res?.data?.id }))
                            }
                        })
                        .catch(err => {
                            console.log('err: ', err);
                            // swal('', err?.message, 'error')
                            // if (err?.message) {
                            //     swal('', err?.message + 'signin', 'error')
                            // }
                        })
                }
            })
            .catch(err => {
                swal('', err.message, 'error')
                // swal('', err?.message + 'outside', 'error')
            })
    };

    useEffect(() => {
        setTimeout(() => {
            if (Timer > 0 && otpModal) {
                setTimer(Timer - 1)
            }
        }, 1000);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Timer, otpModal])


    const handleSearchChange = (e) => {
        const value = e.target.value;
        setKeyword(value);

        if (value.trim().length > 0) {
            const filtered = allProductList
                .filter(item =>
                    item.productName.toLowerCase().includes(value.toLowerCase())
                )
                .slice(0, 5);
            setSuggestions(filtered);
        } else {
            setSuggestions([]);
        }
    };

    const handleClear = () => {
        setKeyword('');
        setSuggestions([]);
    };

    return (
        <>
            {isLoading && <LoaderBox />}


            {locationModal && (
                <div className="modal-backdrop">
                    <div className="modal-box">
                        <button className="modal-close" onClick={() => setLocationModal(false)}>
                            <FiX size={20} />
                        </button>
                        <h2 className="modal-title">
                            let’s start with your pincode<br />
                            <span className="gradient-text">cleaner home comes next.</span>
                        </h2>
                        <p className="modal-subtext">Enter location to explore products in your area</p>

                        <div className="pincode-input-wrapper">
                            <FiMapPin className="input-icon" />
                            <input type="text" placeholder="Type your Pincode..."
                                maxLength={6}
                                pattern="\d{6}"
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (val.length === 6) onDetectLocation(val, "manual");
                                }} />
                        </div>

                        <div className="or-text">or</div>

                        <button className="detect-btn" onClick={() => onDetectLocation(false, 'auto')}>DETECT MY LOCATION</button>
                    </div>
                </div>
            )}
            {/* //logging model */}
            {loginModalStatus && <div className="login-overlay">
                <section className="login-container">
                    <div className="login-card">
                        <div className="login-image-wrapper">
                            <img src={banner1} />
                            <button className="login-close-btn" onClick={() => {
                                dispatch({ type: SHOW_LOGIN_MODAL, payload: false });
                                // setLoggingModel(false); 
                                resetOtpData();
                            }}>
                                &times;
                            </button>
                        </div>
                        <div className="login-content">
                            <h1>
                                let’s get you <span className="login-gradient-text">back in</span>
                            </h1>
                            <p className="login-subtext">
                                If you have an account sign in with Registered phone number.
                            </p>

                            <Form
                                initialValues={otpData ? { phoneNumber: '' } : {}}
                                onSubmit={onFormSubmit}
                                validate={validate}
                            >
                                {({ handleSubmit }) => (
                                    <form onSubmit={handleSubmit}>
                                        <div className="login-input-box">
                                            <FiPhone className="login-icon" />
                                            {/* <span className="phone-prefix">+91</span> */}
                                            <Field
                                                name="phoneNumber"
                                                component={renderNumberInput}
                                                placeholder="Enter your 10 digit mobile number"
                                                type="tel"
                                                inputClasses="floating__input-login"
                                                maxLength={10}
                                            />
                                        </div>
                                        <button type="submit" className="login-submit-btn">Continue</button>
                                    </form>
                                )}
                            </Form>

                            <p className="login-terms">
                                By continuing, you agree to our
                                <a href={toAbsoluteUrl(`/cms/tc`)} target="_blank" rel="noreferrer"> Terms</a>,
                                <a href={toAbsoluteUrl(`/cms/rrd`)} target="_blank" rel="noreferrer"> Refunds</a> and
                                <a href={toAbsoluteUrl(`/cms/tc`)} target="_blank" rel="noreferrer"> Privacy Policy</a>
                            </p>
                        </div>
                    </div>
                </section>
            </div>
            }

            {
                signupModal
                && (
                    <div className="modal-overlay-signup-mob">
                        <section className="signup-container">
                            <div className="signup-card">
                                <div className="signup-image-wrapper">
                                    <img src={banner1} />
                                    <button className="signup-close-btn" onClick={() => { resetOtpData(); setsignupModal(false); }}>
                                        &times;
                                    </button>
                                </div>

                                <div className="signup-content">
                                    <div className='signup-title'>
                                        new here?  <span className="signup-gradient-text">let’s make it official</span>
                                    </div>
                                    <p className="signup-subtext">
                                        Create a account to continue
                                    </p>

                                    <Form
                                        initialValues={otpData ? { ...otpData, phoneNumber: removeMobileFomrmatter(otpData?.phoneNumber) } : {}}
                                        onSubmit={(value, formProps) => onSignUpSubmit(value, formProps)}
                                        validate={CreateAcc}
                                    >
                                        {({ handleSubmit, form }) => (
                                            <form className="form" onSubmit={handleSubmit}>


                                                <div className="signup-input-box">
                                                    <FiPhone className="signup-icon" />
                                                    {/* <span className="phone-prefix">+91</span> */}
                                                    <Field
                                                        name="phoneNumber"
                                                        component={renderNumberInput}
                                                        placeholder="Enter your 10 digit mobile number"
                                                        type="tel"
                                                        inputClasses="floating__input-signup"
                                                        maxLength={10}
                                                    />
                                                </div>
                                                <div className="signup-input-row">
                                                    <div className="signup-input-box-row">
                                                        <FiUser className="signup-icon-row" />
                                                        <Field
                                                            name="firstName"
                                                            component={renderInput}
                                                            placeholder="First Name"
                                                            inputClasses="floating__input-signup"
                                                        />
                                                    </div>
                                                    <div className="signup-input-box-row">
                                                        <FiUser className="signup-icon-row" />
                                                        <Field
                                                            name="lastName"
                                                            component={renderInput}
                                                            placeholder="Last Name"
                                                            inputClasses="floating__input-signup"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="signup-input-box">
                                                    <FiMail className="signup-icon" />
                                                    {/* <span className="phone-prefix">+91</span> */}
                                                    <Field
                                                        name="email"
                                                        component={renderInput}
                                                        placeholder="Email Address (optional)"
                                                        inputClasses="floating__input-signup"

                                                    />
                                                </div>



                                                <button type="submit" className="signup-submit-btn">Sign Up</button>
                                            </form>
                                        )}
                                    </Form>
                                </div>
                            </div>
                        </section>
                    </div>
                )}
            {
                otpModal
                // true
                && (
                    <div className="otp-modal-overlay-mob">
                        <section className="signup-container">
                            <div className="signup-card">
                                <div className="signup-image-wrapper">
                                    <img src={banner1} />
                                    <button className="signup-close-btn" onClick={() => { resetOtpData(); setotpModal(false); }}>
                                        &times;
                                    </button>
                                </div>

                                <div className="signup-content">
                                    <h2 className="otp-title">OTP</h2>

                                    <p className="otp-instruction">
                                        Please enter Verification code sent to <br />
                                        <strong>
                                            +91 {displayPhoneNumber(removeCountryCode(otpData?.phoneNumber))}
                                        </strong>{" "}
                                        <Link
                                            to="/"
                                            className="change-link"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setotpValue("");
                                                setotpModal(false);
                                                if (otpData?.type === "register") {
                                                    setsignupModal(true);
                                                } else {
                                                    dispatch({ type: SHOW_LOGIN_MODAL, payload: true });
                                                    // setLoggingModel(true);
                                                }
                                            }}
                                        >
                                            or Change phone number
                                        </Link>
                                    </p>

                                    <div className="otp-inputs">
                                        <OtpInput
                                            value={otpValue}
                                            onChange={onOtpChange}
                                            isInputNum={true}
                                            numInputs={6}
                                            shouldAutoFocus={true}
                                            inputStyle="otp-box" // this still works
                                            containerStyle="otp-inputs"
                                            separator={<span></span>}
                                        />
                                    </div>

                                    {Timer >= 1 && (
                                        <p className="resend-text">Resend in {Timer} seconds</p>
                                    )}
                                    {Timer < 1 && (
                                        <button type="button" onClick={onResendOtp} className="links-btn">
                                            Resend OTP
                                        </button>
                                    )}
                                    {otpValue.length === 6 && (
                                        <button
                                            type="submit"
                                            onClick={handleOtpSubmit}
                                            className="links-btn"
                                        >
                                            Submit
                                        </button>
                                    )}
                                </div>
                            </div>
                        </section>
                    </div>
                )}

            <header className="mheader-bar">
                {/* <div className="free-shipping-banner">
                    FREE shipping over ₹1500. Order now!
                </div> */}
                <div className="shipping-strip-wrapper">
                    <div className="shipping-strip">
                        <span className="strip-item">Doorstep Delivery in 24 hours </span>
                        <span className="strip-item">Subscribe and Save upto 25% </span>
                        <span className="strip-item">Doorstep Delivery in 24 hours</span>
                        <span className="strip-item">Subscribe and Save upto 25%</span>
                    </div>
                </div>

                <div className="container-fluid">
                    <div className='row justify-content-between'>
                        <div className='col-3 col-md-3 col-lg-3 d-flex align-items-center'>
                            <div className='cls-mheader-left'>
                                <div className='hamburger' onClick={handleClick}>
                                    {click ? (<FaTimes size={20} style={{ color: '#333' }} />) : (<FaBars size={22} style={{ color: '#333' }} />)}
                                </div>
                                {/* {history?.location?.pathname === "/about_clefill" || history?.location?.pathname === "/" &&
                                    <i className="search-btn" onClick={() => setActiveSearch(true)}> <CgSearch style={{ fontSize: '22px', cursor: 'pointer' }} /> </i>
                                } */}
                            </div>
                        </div>
                        <div className="col-6 text-center">
                            {/* <div className="left-box text-center"> */}
                            <div onClick={(e) => { e.preventDefault(); history.push('/') }} className="logo-box">
                                <Link to="/#"> <i>
                                    <Logo />
                                    {/* <img src={Clefill} height="30" width="200" alt="product-img" /> */}
                                </i></Link>
                            </div>
                            {/* </div> */}
                        </div>
                        <div className='col-3 col-md-3 col-lg-3 pl-0'>
                            <div className="right-box">

                                <i className="users" onClick={() => { setshowDropDown(!showDropDown) }}> <BiUser /> </i>
                                <div className={`drop-down ${showDropDown ? 'active' : ''}`} ref={dropDownRef}>
                                    <ul className="drop-downlist">
                                        {isLoggedIn && <li className="bottom-line"> <NavLink to="/" onClick={(e) => { e.preventDefault() }} className="user" >Hello {profileData.firstName} {profileData.lastName}</NavLink> </li>}
                                        <li> <NavLink to="/" onClick={(e) => { e.preventDefault(); handleToggle1() }} className="loction-icon"> {authData?.isValidLocation ? removeQuotsFun(authData?.validLocation) : 'No Location '}&nbsp;{` Change`} </NavLink> </li>
                                        {!isLoggedIn &&
                                            <>
                                                <li>
                                                    <NavLink to="/"
                                                        onClick={e => {
                                                            e.preventDefault()
                                                            if (!isValidLocation) {
                                                                setLocationModal(true)
                                                            }
                                                            else {
                                                                
                                                                dispatch({ type: SHOW_LOGIN_MODAL, payload: true });
                                                                
                                                            }
                                                        }}>
                                                        Sign in
                                                    </NavLink>
                                                </li>
                                                {/* <li>
                                                <NavLink to="/signup"
                                                    onClick={e => {
                                                        e.preventDefault()
                                                        if (!isValidLocation) {
                                                            setLocationModal(true)
                                                        }
                                                        else {
                                                            history.push('/login')
                                                        }
                                                    }}>
                                                    Register
                                                </NavLink>
                                            </li> */}
                                            </>
                                        }
                                        {isLoggedIn &&
                                            <>
                                                <li> <NavLink to="/profile" onClick={(e) => { setshowDropDown(false) }}> My Profile </NavLink> </li>
                                                {/* <li> <NavLink to="/payment" onClick={(e) => { setshowDropDown(false) }}> My Payment </NavLink> </li> */}
                                                <li> <NavLink to="/promocode" onClick={(e) => { setshowDropDown(false) }}> My Promo Code </NavLink> </li>
                                                <li> <NavLink to="/my-subscription" onClick={(e) => { setshowDropDown(false) }}> My Subscription </NavLink> </li>
                                                <li className="bottom-line"> <NavLink to="/referralcode" onClick={(e) => { setshowDropDown(false) }}>Refer & Save!</NavLink> </li>

                                                <li> <NavLink to="/order_list" onClick={(e) => { setshowDropDown(false) }}> My Orders </NavLink> </li>
                                                <li> <NavLink to="/my_reviews" onClick={(e) => { setshowDropDown(false) }}> My Reviews </NavLink> </li>
                                                <li> <NavLink to="/Help-List" onClick={(e) => { setshowDropDown(false) }}> Help Center </NavLink> </li>
                                            </>
                                        }
                                        {isLoggedIn && <li> <NavLink to="/" onClick={() => onLogout()}> Log out </NavLink> </li>}
                                    </ul>
                                </div>
                                {/* {isLoggedIn && <i onClick={(e) => { e.preventDefault(); history.push('/notifications') }} className={`${notificationCount > 0 ? 'green-dots' : ''}`}
                                // style={{
                                //     alignItems: 'center',
                                //     height: '80%', // or a specific height like '40px'
                                // }}
                                > <MdOutlineNotificationsNone /> </i>} */}
                                <i onClick={(e) => {
                                    e.preventDefault();
                                    if (isValidLocation) {
                                        if (isLoggedIn) {
                                            history.push('/cart');
                                        } else {
                                            // setLoggingModel(true);
                                            dispatch({ type: SHOW_LOGIN_MODAL, payload: true });
                                        }
                                    }
                                    else
                                        setLocationModal(true)
                                }} className="cart"> <BsCart2 />  {isLoggedIn ? (cartCount > 0 && <span> {cartCount} </span>) : (cartCountLocal > 0 && <span> {cartCountLocal} </span>)} {/*<b>5000</b>*/} </i>
                            </div>
                        </div>
                    </div>
                </div>

                {history?.location?.pathname !== "/cart" && history?.location?.pathname !== "/payment_method" && history?.location?.pathname !== "/shipping_address" && !history?.location?.pathname.startsWith("/success") &&
                    <div className="category-tabs">
                        <span
                            className={`tab-item ${location.pathname.includes('/product_list/refill/all') ? "active" : ""}`}
                            onClick={(e) => {
                                e.preventDefault()
                                if (!isValidLocation) {
                                    setLocationModal(true)
                                }
                                else {
                                    history.push("/product_list/refill/all")
                                }

                            }}
                        >
                            Refills
                        </span>
                        <span
                            className={`tab-item ${location.pathname.includes('/product_list/prefill/dish-wash-gel') ? "active" : ""}`}
                            onClick={(e) => {
                                e.preventDefault()
                                if (!isValidLocation) {
                                    setLocationModal(true)
                                }
                                else {
                                    history.push("/product_list/prefill/dish-wash-gel")
                                }

                            }}
                        >
                            Dishwash Gel
                        </span>
                        <span
                            className={`tab-item ${location.pathname.includes('/product_list/prefill/laundry-care') ? "active" : ""}`}
                            onClick={(e) => {
                                e.preventDefault()
                                if (!isValidLocation) {
                                    setLocationModal(true)
                                }
                                else {
                                    history.push("/product_list/prefill/laundry-care")
                                }

                            }}
                        >
                            Liquid Detergents
                        </span>

                        <span
                            className={`tab-item ${location.pathname.includes('/product_list/prefill/floor-cleaner') ? "active" : ""}`}
                            onClick={(e) => {
                                e.preventDefault()
                                if (!isValidLocation) {
                                    setLocationModal(true)
                                }
                                else {
                                    history.push("/product_list/prefill/floor-cleaner")
                                }

                            }}
                        >
                            Floor Cleaners
                        </span>
                        <span
                            className={`tab-item ${location.pathname.includes('/product_list/prefill/bathroom-cleaner') ? "active" : ""}`}
                            onClick={(e) => {
                                e.preventDefault()
                                if (!isValidLocation) {
                                    setLocationModal(true)
                                }
                                else {
                                    history.push("/product_list/prefill/bathroom-cleaner")
                                }

                            }}
                        >
                            Bathroom Cleaners
                        </span>
                        <span
                            className={`tab-item ${location.pathname.includes('/product_list/prefill/glass-cleaner') ? "active" : ""}`}
                            onClick={(e) => {
                                e.preventDefault()
                                if (!isValidLocation) {
                                    setLocationModal(true)
                                }
                                else {
                                    history.push("/product_list/prefill/glass-cleaner-")
                                }

                            }}
                        >
                            Glass Cleaners
                        </span>

                        <span
                            className={`tab-item ${location.pathname.includes('/product_list/prefill/toilet-cleaner') ? "active" : ""}`}
                            onClick={(e) => {
                                e.preventDefault()
                                if (!isValidLocation) {
                                    setLocationModal(true)
                                }
                                else {
                                    history.push("/product_list/prefill/toilet-cleaner")
                                }

                            }}
                        >
                            Toilet Cleaners
                        </span>
                    </div>
                }

                {/* // Side Navbar */}
                <div className={`side-menu ${click ? 'open' : ''}`}>
                    <div className="search-container">
                        <FaSearch className="search-icon" />
                        <input className="search-box" type="text"
                            placeholder="search..."
                            value={keyword}
                            onChange={handleSearchChange}
                        />
                    </div>
                    {keyword && suggestions.length > 0 && (
                        <div className="suggestions-box">
                            {suggestions.map((item, idx) => (
                                <div key={idx} className="suggestion-item"
                                    onClick={() => {
                                        history.push(`/product_detail/${item?.productcategory.category.toLowerCase()}/${item?.productName.replace(/\s+/g, '-')}`);
                                        setClick(false);
                                        // setKeyword("")};
                                    }
                                    }>
                                    {item.productName}
                                </div>
                            ))}
                        </div>
                    )}

                    <ul className="menu-items">
                        <li onClick={(e) => {
                                e.preventDefault()
                                if (!isValidLocation) {
                                    setLocationModal(true)
                                }
                                else {
                                    history.push("/product_list/prefill/all")
                                }

                            }}>Shop All</li>
                        {/* <li>Bundle & Save</li> */}
                        <li onClick={() => history.push('/subscribe_and_save')}>Subscribe & Save</li>
                        <li onClick={() => history.push('/about_clefill')}>About Us</li>
                        <li>FAQs</li>
                        <li onClick={() => history.push('/contactus')}>Contact Us</li>
                    </ul>

                </div>

            </header>
            <div className='cls-m-search-header'>
                {(history?.location?.pathname === '/' || history?.location?.pathname === "/about_clefill") && activeSearch &&
                    <div className='row'>
                        <div className='col-12 col-sm-12 col-md-12 col-lg-12'>
                            <div className='search-var-box'>
                                <input type='text' className='floating__input' value={keyword}
                                    onChange={e => {
                                        e.preventDefault()
                                        if (isValidLocation) {
                                            setKeyword(e.target.value)
                                            const value = e.target.value
                                            if (value?.length > 0) {
                                                const filteredNames = allProductList.filter((item) => item?.productName.trim().toLowerCase().includes(value.trim().toLowerCase())).splice(0, 5)
                                                setSuggestions(filteredNames);
                                            } else {
                                                setSuggestions([])
                                                setActiveSearch(false)
                                            }
                                        }
                                        else {
                                            setLocationModal(true)
                                        }
                                    }}
                                    // onBlur={() => {
                                    // setKeyword()
                                    // setSuggestions([])
                                    // }}
                                    placeholder='search product'
                                />
                                <button type='button' className='search-btn' onClick={() => setActiveSearch(false)}><RxCross2 /></button>
                                <ul className='search-reac'>
                                    {keyword && suggestions.map((item, index) => (
                                        <li key={index} onClick={() => { history.push(`/product_detail/${item?.productcategory.category.toLowerCase()}/${item?.productName.replace(/\s+/g, '-')}`) }}>{item?.productName}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                }
            </div>

        </>
    );
}

export default Header;